// Generated from api/openapi/agents.yaml by make docs. Do not edit.
import { z } from "zod";
import { consequencePolicySchema } from "@pureid/auth-core";

export const agentApprovalPolicySchema = z.object({
  "default_consequence_policy": z.unknown().refine((value) => [consequencePolicySchema, z.null()].filter((variant) => variant.safeParse(value).success).length === 1, "Expected exactly one supported variant").pipe(z.union([consequencePolicySchema, z.null()])),
  "configured": z.boolean()
}).strict();
